(function ($, window, document) {

function onDOMContentLoaded() {
  var anchor = window.location.hash.replace('#', '');

  function collapse() {
    var $features = $('.collapse-content__content');

    $features.each(function () {
      if ($(this).attr('id') != anchor) {
        $(this).removeClass('in');
      } else {
        var $target = $('#' + anchor);
        if ($target.length) {
          setTimeout(function () {
            $('html,body').animate({ scrollTop: $target.prev().offset().top }, 1000);
          }, 100);

        }
      }
    });

    // handle aria-hidden on collapsed element
    var collapseList = $('.collapse-content__container');
    $(collapseList).on('show.bs.collapse', function (event) {
      $(event.target).attr('aria-hidden', false);
    })
    $(collapseList).on('hide.bs.collapse', function (event) {
      $(event.target).attr('aria-hidden', true);
    })
  }

  // collapse when document is ready
  collapse();
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})($, window, document);
